import { TextureAtlasUtils } from "../../../Utils/TextuAtlasUtils";
import { Game, eAtlas_0 } from "../../../Game";
import { TIMER } from "../../Gameplay";

export class TouchFx {
    private static readonly START_ALPHA = 0.5;
    private static readonly END_ALPHA = 0;

    private static readonly START_SCALE = 1;
    private static readonly END_SCALE = 2;

    private _entity: pc.Entity;
    private _time: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(parent: pc.GraphNode) {
        let atlas = Game.getTextureAtlas(0);

        this._entity = new pc.Entity();
        this._entity.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: atlas.texture,
            rect: TextureAtlasUtils.getAtlasFrameRegion(atlas, eAtlas_0.tutTouchFx),
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            width: 133,
            height: 132,
        });
        this._entity.element.enabled = false;
        parent.addChild(this._entity);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    show(x: number, y: number): void {
        this._time = TIMER.time;

        this._entity.setLocalPosition(x, y, 0);
        this._entity.element.enabled = true;

        this.update();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._entity.element.enabled = false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        let progress = (TIMER.time - this._time) / 700;

        if (progress < 1) {
            let scale = pc.math.lerp(TouchFx.START_SCALE, TouchFx.END_SCALE, pc.SineOut(progress));

            this._entity.setLocalScale(scale, scale, scale);
            this._entity.element.opacity = pc.math.lerp(TouchFx.START_ALPHA, TouchFx.END_ALPHA, progress);
        }
        else {
            progress = 1;
            this._entity.element.enabled = false;
        }
    }
}